"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileChunk = function (file, offset, chunkSize) {
    var fileChunk;
    // Edge does not support File constructor
    if (!/Edge/.test(navigator.userAgent)) {
        fileChunk = new File([file.slice(offset, offset + chunkSize)], file.name);
    }
    else {
        fileChunk = new Blob([file.slice(offset, offset + chunkSize)], { type: 'video/*' });
        fileChunk.name = file.name;
    }
    return fileChunk;
};
